import { useServiceRouter } from '@common/components/ServiceRouter';

export default function getAppointmentTranslationKey() {
	const { checkService } = useServiceRouter();

	switch (true) {
		case checkService('talented'):
			return 'appointment.talented';
		case checkService('lyceum'):
			return 'appointment.lyceum';
		default:
			return 'appointment.main';
	}
}
